import { render, staticRenderFns } from "./SalesPromotionDetails.vue?vue&type=template&id=570b25c0&"
import script from "./SalesPromotionDetails.vue?vue&type=script&lang=js&"
export * from "./SalesPromotionDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports